module.exports = __webpack_public_path__ + "media/warehouse_by_volume/Img-12m2-722f5b7d.png";